import { useEffect, useState } from "react";
import { initials, stars, ytThumb } from "../lib/format";

function BeforeAfterCell({ src, label }) {
  const [err, setErr] = useState(false);
  const showImg = src && !err;
  return (
    <div className="ba-cell">
      {showImg ? (
        <img src={src} alt={label} loading="lazy" onError={() => setErr(true)} />
      ) : (
        <div className="ph" style={{ display: "flex" }}>
          <i className="fa-solid fa-image" />
          {label}
        </div>
      )}
      <span className="ba-label">{label}</span>
    </div>
  );
}

function Media({ t, onPlay }) {
  if (t.kind === "video") {
    if (t.youtube) {
      return (
        <div className="t-video" onClick={() => onPlay(t.youtube)}>
          <img src={ytThumb(t.youtube)} alt={`${t.name} video testimonial`} loading="lazy" />
          <div className="yt-tag">
            <i className="fa-brands fa-youtube" /> Video
          </div>
          <div className="play">
            <i className="fa-solid fa-play" />
          </div>
        </div>
      );
    }
    return (
      <div className="t-video" style={{ cursor: "default" }}>
        <div className="play">
          <i className="fa-solid fa-play" style={{ background: "rgba(255,255,255,.15)" }} />
        </div>
        <div className="yt-tag">
          <i className="fa-brands fa-youtube" /> Video coming soon
        </div>
      </div>
    );
  }
  if (t.kind === "beforeafter") {
    return (
      <div className="t-ba">
        <BeforeAfterCell src={t.before_image} label="Before" />
        <BeforeAfterCell src={t.after_image} label="After" />
      </div>
    );
  }
  return null;
}

function VideoLightbox({ youtube, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="vid-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="vid-box">
        <button className="vid-close" onClick={onClose}>
          &times;
        </button>
        <div className="vid-frame">
          <iframe
            src={`https://www.youtube.com/embed/${youtube}?autoplay=1&rel=0`}
            title="Client testimonial"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}

export default function Testimonials({ testimonials }) {
  const [playing, setPlaying] = useState(null);

  return (
    <section id="testimonials" className="section testimonials">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Real results</span>
          <h2>Client stories &amp; testimonials</h2>
          <p>
            Watch video testimonials, see before-and-after journeys, and read what our clients experienced with our
            natural products.
          </p>
        </div>
        <div className="t-grid">
          {testimonials.map((t) => (
            <div className="t-card" key={t.id}>
              <Media t={t} onPlay={setPlaying} />
              <div className="t-body">
                <div className="t-stars">{stars(t.stars || 5)}</div>
                <div className="t-quote">
                  <span>{t.quote}</span>
                </div>
                <div className="t-meta">
                  <div className="av">{initials(t.name)}</div>
                  <div>
                    <b>{t.name}</b>
                    <small>{t.concern}</small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="t-disclaimer">
          <i className="fa-solid fa-circle-info" /> These are individual client experiences shared with their consent.
          Results vary from person to person and are not guaranteed. Testimonials are not medical claims — please consult
          a healthcare professional regarding your own health.
        </p>
      </div>
      {playing && <VideoLightbox youtube={playing} onClose={() => setPlaying(null)} />}
    </section>
  );
}
